import { Spinner as Spinner_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const Spinner = forwardRef(({ ...props }, ref) => {
    return <Spinner_ ref={ref} {...props}>{props?.children}</Spinner_>
});